/**
* @license nested-property https://github.com/cosmosio/nested-property
*
* The MIT License (MIT)
*
* Copyright (c) 2014-2015 Olivier Scherrer <pode.fr@gmail.com>
*/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

module.exports = {
  set: setNestedProperty,
  get: getNestedProperty,
  has: hasNestedProperty,
  hasOwn: function hasOwn(object, property, options) {
    return this.has(object, property, options || {
      own: true
    });
  },
  isIn: isInNestedProperty
};
/**
 * Get the property of an object nested in one or more objects
 * given an object such as a.b.c.d = 5, getNestedProperty(a, "b.c.d") will return 5.
 * @param {Object} object the object to get the property from
 * @param {String} property the path to the property as a string
 * @returns the object or the the property value if found
 */

function getNestedProperty(object, property) {
  if (object && _typeof(object) == "object") {
    if (typeof property == "string" && property !== "") {
      var split = property.split(".");
      return split.reduce(function (obj, prop) {
        return obj && obj[prop];
      }, object);
    } else if (typeof property == "number") {
      return object[property];
    } else {
      return object;
    }
  } else {
    return object;
  }
}
/**
 * Tell if a nested object has a given property (or array a given index)
 * given an object such as a.b.c.d = 5, hasNestedProperty(a, "b.c.d") will return true.
 * It also returns true if the property is in the prototype chain.
 * @param {Object} object the object to get the property from
 * @param {String} property the path to the property as a string
 * @param {Object} options:
 *  - own: set to reject properties from the prototype
 * @returns true if has (property in object), false otherwise
 */


function hasNestedProperty(object, property, options) {
  options = options || {};

  if (object && _typeof(object) == "object") {
    if (typeof property == "string" && property !== "") {
      var split = property.split(".");
      return split.reduce(function (obj, prop, idx, array) {
        if (idx == array.length - 1) {
          if (options.own) {
            return !!(obj && obj.hasOwnProperty(prop));
          } else {
            return !!(obj !== null && _typeof(obj) == "object" && prop in obj);
          }
        }

        return obj && obj[prop];
      }, object);
    } else if (typeof property == "number") {
      return property in object;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
/**
 * Set the property of an object nested in one or more objects
 * If the property doesn't exist, it gets created.
 * @param {Object} object
 * @param {String} property
 * @param value the value to set
 * @returns object if no assignment was made or the value if the assignment was made
 */


function setNestedProperty(object, property, value) {
  if (object && _typeof(object) == "object") {
    if (typeof property == "string" && property !== "") {
      var split = property.split(".");
      return split.reduce(function (obj, prop, idx) {
        var nextPropIsNumber = Number.isInteger(Number(split[idx + 1]));
        obj[prop] = obj[prop] || (nextPropIsNumber ? [] : {});

        if (split.length == idx + 1) {
          obj[prop] = value;
        }

        return obj[prop];
      }, object);
    } else if (typeof property == "number") {
      object[property] = value;
      return object[property];
    } else {
      return object;
    }
  } else {
    return object;
  }
}
/**
 * Tell if an object is on the path to a nested property
 * If the object is on the path, and the path exists, it returns true, and false otherwise.
 * @param {Object} object to get the nested property from
 * @param {String} property name of the nested property
 * @param {Object} objectInPath the object to check
 * @param {Object} options:
 *  - validPath: return false if the path is invalid, even if the object is in the path
 * @returns {boolean} true if the object is on the path
 */


function isInNestedProperty(object, property, objectInPath, options) {
  options = options || {};

  if (object && _typeof(object) == "object") {
    if (typeof property == "string" && property !== "") {
      var split = property.split("."),
          isIn = false,
          pathExists;
      pathExists = !!split.reduce(function (obj, prop) {
        isIn = isIn || obj === objectInPath || !!obj && obj[prop] === objectInPath;
        return obj && obj[prop];
      }, object);

      if (options.validPath) {
        return isIn && pathExists;
      } else {
        return isIn;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}